import { FileWriterTemplatePayload, fileWriterPrefix, urlCombine } from 'ihub/common';
import { handleResponse, microServiceAPI, standardPost } from '../classes/http-helper-const';
import HttpResponseOptions from '../interface/http-response-options';

export class FileWriterHttpService {
	private getTemplatePath = 'GetTemplate';

	async getTemplate(
		fileWriterTemplatePayload: FileWriterTemplatePayload,
		options?: HttpResponseOptions
	) {
		const url = urlCombine(microServiceAPI, fileWriterPrefix, this.getTemplatePath);
		const response = await standardPost(url, fileWriterTemplatePayload);
		return await handleResponse(response, 'Get Template', fileWriterPrefix, options);
	}
}
